module.exports = __webpack_public_path__ + "img/3m.5aca5848.jpg";